export default __webpack_public_path__ + "images/b49d84a404556b8cd3ff21112e5843a8-Eventbrite_NYE_HomepageA_1067x312.webp";